import React, { useEffect, useState } from 'react';
import { useTrilogyContext } from '../../context';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import Icon from '../icon/Icon';
import { is } from '../../services';
/**
 * Fab Component - Floating Button Action
 * @param children {ReactNode} Text for fab button
 * @param extended {boolean} extend fab button
 * @param iconName {IconName | IconNameValues} name of icon
 * @param accessibilityLabel {string} Accessibility label
 * @param onClick {ClickEvent} onClick Event
 * @param className {string} Additional CSS Classes (only web)
 * @param fixed {boolean} position fixed,true by dyfault
 * @param top {number} position top
 * @param left {number} position left
 * @param bottom {number} position bottom
 * @param right {number} position right
 **/
const Fab = ({ children, extended, iconName, accessibilityLabel, onClick, className, fixed = true, top, bottom, left, right, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const [isExtended, setIsExtended] = useState(extended || false);
    useEffect(() => {
        setIsExtended(extended || false);
    }, [isExtended]);
    const positionStyle = top || bottom || left || right
        ? {
            position: fixed ? 'fixed' : 'absolute',
            top: top !== null && top !== void 0 ? top : 'auto',
            bottom: bottom !== null && bottom !== void 0 ? bottom : 'auto',
            left: left !== null && left !== void 0 ? left : 'auto',
            right: right !== null && right !== void 0 ? right : 'auto',
        }
        : {
            position: 'relative',
        };
    const _className = hashClass(styled, clsx('fab', extended && is('extended'), className));
    return (React.createElement("button", { "data-testid": testId, "aria-label": accessibilityLabel, onClick: (e) => {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            e.stopPropagation();
        }, style: { ...positionStyle }, ...others, className: _className },
        React.createElement(Icon, { name: iconName }),
        children));
};
export default Fab;
//# sourceMappingURL=Fab.js.map